import React from 'react'
import { Auth } from 'services'
import history from 'src/history'
import { Loader } from 'components'

interface Props {
    auth: Object
}

const auth = new Auth()

export default class Unauthorized extends React.Component<Props> {

    public componentWillMount() {
        auth.logout()
        history.replace('/login')
    }

    public render() {
        return (
            <Loader />
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Unauthorized/index.tsx